import { usePopperTooltip } from 'react-popper-tooltip';

import {
  Icon,
  Typography
} from '@/modules/perseo-billing/ui/react/src/components/beta';

import './tooltip.scss';

type TTooltip = {
  title: string;
  description?: string;
};

export const Tooltip = ({ title, description }: TTooltip) => {
  const {
    getArrowProps,
    getTooltipProps,
    setTooltipRef,
    setTriggerRef,
    visible
  } = usePopperTooltip({
    placement: 'top',
    trigger: 'hover'
  });

  return (
    <div ref={setTriggerRef} className="co-flex co-items-center">
      <Icon
        icon="InformationIcon"
        height={20}
        width={20}
        className="co-fill-current co-text-pds-neutral-900"
      />
      {visible && (
        <div
          ref={setTooltipRef}
          {...getTooltipProps({
            className:
              'tooltip-container co-max-w-300px co-flex co-flex-col co-p-16px co-gap-4px co-rounded-[6px] co-bg-[#313131]'
          })}
        >
          <div
            {...getArrowProps({
              className: 'tooltip-arrow'
            })}
          />
          <Typography
            weight="semibold"
            size="body2"
            leading="16px"
            color="white"
          >
            {title}
          </Typography>
          {description && (
            <Typography
              weight="medium"
              size="body2"
              leading="16px"
              color="white"
            >
              {description}
            </Typography>
          )}
        </div>
      )}
    </div>
  );
};
